import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as CloseIcon } from "../../assets/Icons/cross.svg";
import { getUserSubscription, analytics2, authenticate } from "../../network/service";
import { socialAccountLink ,setCookie} from "../../Screens/Accounts/Login/service";
import { useNavigate } from "react-router-dom";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import { getUserDetails } from "../../Redux/UserDetailsSlice/UserDetailsSlice";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getLanguageModal } from "../../Redux/LanguageModal/languageModalSlice";

const SocialAccountLoginModal = ({
  setShowSocialLoginModal,
  modalType,
  handleClose
}) => {
 
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };
  let SocialData =  modalType?.values;

  const [msgSuccessLogin, setMsgSucessLogin] = useState("");
  const [isSuccessLoginMsg, setIsSuccessLoginMsg] = useState(false);

  useEffect(() => {
    if (isSuccessLoginMsg) {
      toast.success(msgSuccessLogin, {
        position: "top-center",
      });
    }
  }, [isSuccessLoginMsg, msgSuccessLogin]);

  const closeHandler = () => {
    setShowSocialLoginModal(false);
    if (handleClose) {
      handleClose();
    }
  };

  const onSocialLink = async () => {
    
    try {
      const response = await socialAccountLink(appInfo,modalType?.values);
      const loginSocialData = response.data.data[0];
      localStorage.setItem("userId", loginSocialData.user_id);
      localStorage.setItem("isLoggedIn", true);
      localStorage.setItem("userName", loginSocialData.first_name);
      setCookie("userId", loginSocialData.user_id, 30);
      setCookie("userEmail", SocialData.email, 30);
      setCookie("isLoggedIn", "true", 30);

      const authResponse = await authenticate(appInfo);
      if (authResponse) {
        localStorage.setItem('selectedLanguageCode', authResponse?.data?.user_language?.short_code ? authResponse?.data?.user_language?.short_code : authResponse?.user_language?.short_code);
        localStorage.setItem('selectedLanguageId', authResponse?.data?.user_language?.language_id ? authResponse?.data?.user_language?.language_id : authResponse?.user_language?.language_id);
        dispatch(
          getLanguageModal({
            languageModal: {
              selectedLanguageCode: authResponse?.data?.user_language?.short_code ? authResponse?.data?.user_language?.short_code : authResponse?.user_language?.short_code
            }
          })
        );
        dispatch(
          getAccessToken({
            accessToken: authResponse?.data?.token ? authResponse?.data?.token : authResponse?.token,
          })
        );
        dispatch(
          getUserDetails({
            userDetails: authResponse?.data ? authResponse?.data : authResponse,
          })
        );
        dispatch(
          getUser({
            user: loginSocialData.user_id,
          })
        );
      }

      await analytics2(
        loginSocialData.user_id,
        appInfo,
        loginSocialData.user_email || SocialData.email,
        loginSocialData.first_name
      );

      setMsgSucessLogin("You are successfully logged in.");
      setIsSuccessLoginMsg(true);
      let delay = 1000;
      try {
        const subscriptionResponse = await getUserSubscription(loginSocialData.user_id);
        const user_sub = subscriptionResponse.data;
        delay = user_sub.length > 0 ? 1000 : 5000;
      } catch (e) {}
      setTimeout(() => {
        setIsSuccessLoginMsg(false);
        navigate(-1);
      }, delay);
    } catch (error) {
      console.error(`Error linking ${modalType?.values?.loginType} account:`, error);
     
    }
  };


  return (
    <div className="socialLoginModal">
      <ToastContainer />
      <div className="overlayModal" onClick={closeHandler}></div>
      {modalType?.values?.loginType && (
        <div className="closeIconContainer" onClick={closeHandler}>
          <CloseIcon />
        </div>
      )}
      
      <div className="contents">
        { 
          <>
            <h1>{modalType?.heading}</h1>
            <div className="buttonContainer">
              <button onClick={onSocialLink}>Yes</button>
              <button onClick={closeHandler}>No</button> 
            </div>
          </>
        }

      </div>
    </div>
  );
};

export default SocialAccountLoginModal;
